export const LOGIN = 'LOGIN'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_ERROR = 'LOGIN_ERROR'

export const FETCH_ACCOUNT = 'FETCH_ACCOUNT'
export const FETCH_ACCOUNT_SUCCESS = 'FETCH_ACCOUNT_SUCCESS'
export const FETCH_ACCOUNT_ERROR = 'FETCH_ACCOUNT_ERROR'

export const UPDATE_ACCOUNT = 'UPDATE_ACCOUNT'
export const UPDATE_ACCOUNT_SUCCESS = 'UPDATE_ACCOUNT_SUCCESS'
export const UPDATE_ACCOUNT_ERROR = 'UPDATE_ACCOUNT_ERROR'

export const FETCH_CONFIRMATION = 'FETCH_CONFIRMATION'
export const FETCH_CONFIRMATION_SUCCESS = 'FETCH_CONFIRMATION_SUCCESS'
export const FETCH_CONFIRMATION_ERROR = 'FETCH_CONFIRMATION_ERROR'

export const CONFIRM_REGISTRATION = 'CONFIRM_REGISTRATION'
export const CONFIRM_REGISTRATION_SUCCESS = 'CONFIRM_REGISTRATION_SUCCESS'
export const CONFIRM_REGISTRATION_ERROR = 'CONFIRM_REGISTRATION_ERROR'

export const DELETE_ACCOUNT = 'DELETE_ACCOUNT'
export const DELETE_ACCOUNT_SUCCESS = 'DELETE_ACCOUNT_SUCCESS'
export const DELETE_ACCOUNT_ERROR = 'DELETE_ACCOUNT_ERROR'

export const FETCH_NOTIFICATION_SETTINGS = 'FETCH_NOTIFICATION_SETTINGS'
export const FETCH_NOTIFICATION_SETTINGS_SUCCESS = 'FETCH_NOTIFICATION_SETTINGS_SUCCESS'
export const FETCH_NOTIFICATION_SETTINGS_ERROR = 'FETCH_NOTIFICATION_SETTINGS_ERROR'

export const UPDATE_NOTIFICATION_SETTINGS = 'UPDATE_NOTIFICATION_SETTINGS'
export const UPDATE_NOTIFICATION_SETTINGS_SUCCESS = 'UPDATE_NOTIFICATION_SETTINGS_SUCCESS'
export const UPDATE_NOTIFICATION_SETTINGS_ERROR = 'UPDATE_NOTIFICATION_SETTINGS_ERROR'

export const UNSUBSCRIBE_EMAILS = 'UNSUBSCRIBE_EMAILS'
export const UNSUBSCRIBE_EMAILS_SUCCESS = 'UNSUBSCRIBE_EMAILS_SUCCESS'

export const UPDATE_PHOTO_FILTER = 'UPDATE_PHOTO_FILTER'
export const UPDATE_PHOTO_FILTER_SUCCESS = 'UPDATE_PHOTO_FILTER_SUCCESS'
export const UPDATE_PHOTO_FILTER_ERROR = 'UPDATE_PHOTO_FILTER_ERROR'

export const FETCH_SUBSCRIPTIONS = 'FETCH_SUBSCRIPTIONS'
export const FETCH_SUBSCRIPTIONS_SUCCESS = 'FETCH_SUBSCRIPTIONS_SUCCESS'
export const FETCH_SUBSCRIPTIONS_ERROR = 'FETCH_SUBSCRIPTIONS_ERROR'

export const CANCEL_SUBSCRIPTION = 'CANCEL_SUBSCRIPTION'
export const CANCEL_SUBSCRIPTION_SUCCESS = 'CANCEL_SUBSCRIPTION_SUCCESS'
export const CANCEL_SUBSCRIPTION_ERROR = 'CANCEL_SUBSCRIPTION_ERROR'

export const RESEND_CONFIRMATION_EMAIL = 'RESEND_CONFIRMATION_EMAIL'
export const RESEND_CONFIRMATION_EMAIL_SUCCESS = 'RESEND_CONFIRMATION_EMAIL_SUCCESS'
export const RESEND_CONFIRMATION_EMAIL_ERROR = 'RESEND_CONFIRMATION_EMAIL_ERROR'

export const SUBMIT_HELP_FORM = 'SUBMIT_HELP_FORM'

export const INTRO_START = 'INTRO_START'
export const INTRO_FINISH = 'INTRO_FINISH'
